import { toast } from "react-toastify";

import {
  PostCustomShippingRateRequestBodyType,
  PostCustomShippingRateRequestPathParamType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const postCustomShippingRate = async (
  payload: ApiRequest<
    PostCustomShippingRateRequestBodyType,
    PostCustomShippingRateRequestPathParamType
  >
) => {
  const resp = await api.post<string, PostCustomShippingRateRequestBodyType>(
    `/v2/organizations/custom-shipping-rate/${payload.pathParams.experienceId}`,
    payload.body
  );
  return resp.data;
};

export const usePostCustomShippingRate = () => {
  return useMutation<
    string,
    Error,
    ApiRequest<
      PostCustomShippingRateRequestBodyType,
      PostCustomShippingRateRequestPathParamType
    >,
    any
  >({
    mutationFn: async (data) => postCustomShippingRate(data),
    onSuccess: () => {
      toast.success("Support has been notified of your custom rate request!");
    },
  });
};
